import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";


import LiveFeedCollective from "../jobs/LiveFeedCollective";
import QRCode from "react-qr-code";

/* import DeletedCustomer from "./DeleteOrders";  */


const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const Collective = ({ email }) => {
    const [OrderList, setOrderList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [collectiveList, setcollectiveList] = useState([]);
    const [GroupLiveFeed, setGroupLiveFeed] = useState(false);
    const [currentCollective, setCurrentCollective] = useState("");
    const [collectiveName, setCollectiveName] = useState("");

    const [selectedDayRange, setSelectedDayRange] = useState({
        from: null,
        to: null,
    });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    useEffect(() => {
        const geCollectiveGroup = async () => {
            try {
                const response = await axios.get(`${server_backend}/collective/list`, headers);
                if (response.data.RES_CODE === "00") {
                 
                    setcollectiveList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        geCollectiveGroup();
    }, []);

    const getOrders = async () => {

        try {
            const response = await axios.get(`${server_backend}/Orders/list`, headers);

            if (response.data.RES_CODE === "00") {
                setOrderList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }


    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);

        if (filtersEnabled) {
            FilterCustomer();
        }
    };

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCustomer = async () => {
        try {
            const response = await axios.get(`${server_backend}/Orders/search?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setOrderList(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [filterBy, filterStatus, filterValue]);

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = collectiveList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(collectiveList.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDateChange = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };

    const closeViewCollective = () => {
        setGroupLiveFeed(false);
    }


    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            {GroupLiveFeed ? (
                <LiveFeedCollective currentCollective={currentCollective} closeViewCollective={closeViewCollective} currentCollectiveName={collectiveName}/>
            ) : (
                
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0">Collective</h4>
                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Collective</a></li>
                                            <li className="breadcrumb-item active">List</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card" id="tasksList">
                                    <div className="card-header border-0">
                                        <div className="d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">All Collective </h5>
                                            <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                    <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                </button>
                                            </div>
                                            <div className="flex-shrink-0">
                                                <Link className="btn btn-success add-btn" to="/create-Order">
                                                    <i className="ri-add-line align-bottom me-1"></i> Generate Order
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    {filtersEnabled && (
                                        <div className="card-body border border-dashed border-end-0 border-start-0">
                                            <div className="row g-3">
                                                <div className="col-4">
                                                    <div className="input-light">
                                                        <select
                                                            className="form-control custom-select-style"
                                                            name="choices-single-default"
                                                            disabled={!filtersEnabled}
                                                            value={filterBy}
                                                            onChange={handleFilterByChange}
                                                        >
                                                            <option value="">Filter by</option>
                                                            <option value="colle_id">ID</option>
                                                            <option value="name">Group</option>
                                                            <option value="reprint">Reprint</option>
                                                        </select>

                                                    </div>
                                                </div>
                                                
                                                <div className="col-12">
                                                    <div className="search-box">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder="Search for tasks or something..."
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterValueChange}
                                                        />
                                                        <i className="ri-search-line search-icon"></i>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    )}

                                    <div className="card-body">
                                        <div
                                            className="table-responsive table-card mb-4"
                                            style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                                        >
                                            <div className="table-responsive" style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "90vh" }}>
                                                <table className="table align-middle table-nowrap mb-0" id="tasksTable" style={{ maxWidth: "95%", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", borderRadius: "10px", overflow: "hidden" }}>
                                                    <thead className="table-light text-muted">
                                                        <tr style={{ textAlign: "center", fontSize: "14px" }}>
                                                            <th className="th-hover" onClick={() => handleColumnClick("colle_id")}>ID</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("name")}>Group</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("price")}>Reprint</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("purity")}>QR Code</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("purity")}>Show Group</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="list form-check-all">
                                                        {collectiveList.map((Collective_L) => (
                                                            <tr key={Collective_L.colle_id} style={{ textAlign: "center", fontSize: "13px", backgroundColor: "#ffffff", borderBottom: "1px solid #f0f0f0" }}>
                                                                <th scope="row">
                                                                    <div className="form-check" style={{ padding: "10px 0" }}>
                                                                        <center> {`${Collective_L.colle_id}`}</center>
                                                                    </div>
                                                                </th>
                                                                <td style={{ padding: "10px" }}>
                                                                    {Collective_L.name}
                                                                </td>

                                                                <td className="name" style={{ padding: "10px", color: "#ff6b6b", fontWeight: "bold" }}>
                                                                    {Collective_L.reprint || 0}
                                                                </td>

                                                                <td style={{ padding: "10px" }}>
                                                                    <QRCode
                                                                        size={50}
                                                                        style={{ height: "15vh", width: "15vh", border: "1px solid #ccc", borderRadius: "8px", padding: "5px" }}
                                                                        value={`${server_frontend}/jobs/collective/qr-group?group=${Collective_L.colle_id}`}
                                                                        viewBox="0 0 256 256"
                                                                    />
                                                                </td>

                                                                <td className="name" style={{ padding: "10px" }}>
                                                                    <button className="btn btn-outline-secondary" style={{ padding: "5px 10px", borderRadius: "5px" }} onClick={() => {
                                                                        setCurrentCollective(Collective_L.colle_id);
                                                                        setCollectiveName(Collective_L.name);
                                                                        setGroupLiveFeed(true);
                                                                    }}>
                                                                        View Group
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                        <div className="row justify-content-between align-items-center">
                                            <div className="col-auto me-3">
                                                <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, collectiveList.length)} of {collectiveList.length} entries</p>
                                            </div>
                                            <div className="col-auto">
                                                <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                    </li>
                                                    {Array.from({ length: totalPages }, (_, index) => (
                                                        <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                        </li>
                                                    ))}
                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="row g-0 text-center text-sm-start">
                                            <div className="col-sm-6">
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
            )}
        </div>
    );
};

export default Collective;
